import React from 'react';
import { PaintBucket, Layers, Store, Home, QrCode, Maximize2, Trophy, RefreshCw } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  PaintBucket: PaintBucket,
  Layers: Layers,
  Store: Store,
  Home: Home,
  QrCode: QrCode,
  Maximize2: Maximize2,
  Trophy: Trophy,
  RefreshCw: RefreshCw
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            What We <span className="text-purple-400">Do</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto"></div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-gray-900/50 border border-gray-800 rounded-lg p-8 hover:border-purple-500 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="w-16 h-16 bg-purple-600/20 rounded-lg flex items-center justify-center group-hover:bg-purple-600/30 transition-colors">
                    <IconComponent className="w-8 h-8 text-purple-400" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-purple-400 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {service.description}
                </p>

                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-purple-500/0 group-hover:border-purple-500/50 rounded-tr-lg transition-all duration-300"></div>
              </div>
            );
          })}
        </div>

        {/* Bottom tagline */}
        <div className="text-center mt-16">
          <p className="text-xl text-gray-400">
            From concept to completion, we bring your vision to life
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
